import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { UserCoupleIcon, UserGroupIcon, UserIcon } from '../../components';
import styles from './Participants.module.scss';
const ParticipantsIcon = ({ isCouple, isGroup }) => {
    if (isCouple) {
        return _jsx(UserCoupleIcon, { ariaHidden: true, className: styles.icon });
    }
    if (isGroup) {
        return _jsx(UserGroupIcon, { ariaHidden: true, className: styles.icon });
    }
    return _jsx(UserIcon, { ariaHidden: true, className: styles.icon });
};
const Participants = ({ a11yAmountOfParticipants, label, maxParticipants, }) => {
    const isCouple = !!(maxParticipants && maxParticipants === 2);
    const isGroup = !!(maxParticipants && maxParticipants > 2);
    return (_jsxs("div", { className: classNames(styles.participantsWrapper, 'd-flex align-items-center'), children: [_jsx(ParticipantsIcon, { isCouple: isCouple, isGroup: isGroup }), _jsx("span", { className: "screenReaderOnly", children: a11yAmountOfParticipants }), _jsx("span", { className: "text-truncate", children: label })] }));
};
export { Participants };
